import { ChangeDetectionStrategy, Component, Signal, inject } from "@angular/core";
import { Router } from "@angular/router";
import { getLanguageValues } from "@utils";
import { FuturesModeService } from "@services";
import { TranslocoModule } from "@ngneat/transloco";

@Component({
  selector: "app-futures-toggle-button",
  imports: [TranslocoModule],
  templateUrl: "./futures-toggle-button.component.html",
  styleUrl: "./futures-toggle-button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FuturesToggleButtonComponent {
  private readonly _router: Router = inject(Router);
  private readonly _futuresModeService: FuturesModeService = inject(FuturesModeService);

  public readonly isFuturesRoute: Signal<boolean> = this._futuresModeService.isFuturesRoute;

  public toggleFuturesVersionOfPage(): void {
    const url: string = this._router.url;
    const queryAndFragmentMatch: RegExpMatchArray | null = url.match(/[?#].*$/);
    const queryAndFragment: string = queryAndFragmentMatch ? queryAndFragmentMatch[0] : "";
    const path: string = queryAndFragment ? url.slice(0, -queryAndFragment.length) : url;

    const segments: string[] = path.split("/").filter((segment: string): boolean => segment !== "");
    const langSegmentCount: number = getLanguageValues().includes(segments[0]) ? 1 : 0;
    const langSegments: string[] = segments.slice(0, langSegmentCount);

    if (this._isChallengeDetailRoute(segments.slice(langSegmentCount))) {
      const dashboardSegments: string[] = this.isFuturesRoute()
        ? [...langSegments, "dashboard"]
        : [...langSegments, "futures", "dashboard"];

      this._router.navigateByUrl(`/${dashboardSegments.join("/")}`);
      return;
    }

    const newSegments: string[] = this.isFuturesRoute()
      ? segments.filter((segment: string): boolean => segment !== "futures")
      : [...langSegments, "futures", ...segments.slice(langSegmentCount)];

    this._router.navigateByUrl(`/${newSegments.join("/")}${queryAndFragment}`);
  }

  // Challenge ids differ between CFD and Futures accounts, so a detail page can't be toggled
  // in place -- send the user to the equivalent dashboard root instead.
  private _isChallengeDetailRoute(routeSegments: string[]): boolean {
    return (
      (routeSegments[0] === "dashboard" &&
        routeSegments[1] === "challenges" &&
        routeSegments.length === 3) ||
      (routeSegments[0] === "futures" &&
        routeSegments[1] === "dashboard" &&
        routeSegments[2] === "challenges" &&
        routeSegments.length === 4)
    );
  }
}
